import './HelpfulDocumentsNJ.css'

const HelpfulDocumentsNJ = ({ policyType, effectiveDate }) => {
    var coverageSelectionForm = ""
    var njLawChangeDate = new Date(2026, 0, 1, 0, 0) // Jan 1st, 2026
    // Determine which form to use based on effective date and policy type
    if (new Date(effectiveDate) >= njLawChangeDate) { // NJ Law Change
        if (policyType == "Standard") {
            coverageSelectionForm = "https://assets.cure.com/pdf/NJC-SCSF_01_26.pdf"
        }
        else {
            coverageSelectionForm = "https://assets.cure.com/pdf/NJC-BCSF_02_23.pdf"
        }
    }
    else {
        coverageSelectionForm = `https://assets.cure.com/pdf/forms/${policyType === "Standard" ? "Standard" : "Basic"}_CSF-0223.pdf`
    }

    return (
        <>
            <div className="fw-bold">
                Helpful Documents for Reference:
                <br />
                <div className="helpful-links-container">
                    <a href={coverageSelectionForm} className='helpful-nj-link' target="_blank">
                        NJ {policyType === "Standard" ? "Standard" : "Basic"} Coverage Selection Form
                    </a>
                    <br />
                    <a href="https://assets.cure.com/pdf/forms/NJC-BG-0123.pdf" className='helpful-nj-link' target="_blank">
                        NJ Buyer's Guide
                    </a>
                </div>
            </div>
        </>
    )
}

export default HelpfulDocumentsNJ